import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { keyName as dealKeyName } from "models/deals/apiDeal";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";

const path = `${baseUrl}/sharing`;
const pathLink = `${baseUrl}/deal-sharing-link`;
const keyName = "Sharing";
const keyNameLink = "DealSharingLink";

export const {
  useGetAll: useAllSharing,
  useGet: useSharing,
  useCreate: useCreateSharing,
  useUpdate: useUpdateSharing,
  useDelete: useDeleteSharing,
} = apiCrudBuilder(path, keyName);

export const useForceSharing = (options) => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: ({ id, ...data }) =>
      appAxios.post(`${path}/${id}/force_sharing/`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [`all_${keyNameLink}`] });
      queryClient.invalidateQueries({ queryKey: [`all_${dealKeyName}`] });
    },
  });
};

export const useExcludeSharing = (options) => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: ({ id, ...data }) =>
      appAxios.post(`${path}/${id}/exclude_sharing/`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [`all_${keyNameLink}`] });
      queryClient.invalidateQueries({ queryKey: [`all_${dealKeyName}`] });
    },
  });
};

export const useUpdateDealSharing = (options) => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: (data) => appAxios.post(`${path}/update_deal_sharing/`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [`all_${keyNameLink}`] });
      queryClient.invalidateQueries({ queryKey: [`all_${dealKeyName}`] });
    },
  });
};

export const useGenerateSharingEmails = (options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: (data) => appAxios.post(`${path}/generate_emails/`, data),
  });
};

export const {
  useGetAll: useAllDealSharingLink,
  useGet: useDealSharingLink,
  useCreate: useCreateDealSharingLink,
  useUpdate: useUpdateDealSharingLink,
  useDelete: useDeleteDealSharingLink,
} = apiCrudBuilder(pathLink, keyNameLink);
